import { render, staticRenderFns } from "./AppCart.vue?vue&type=template&id=4d971186&scoped=true&"
import script from "./AppCart.vue?vue&type=script&lang=js&"
export * from "./AppCart.vue?vue&type=script&lang=js&"
import style0 from "./AppCart.vue?vue&type=style&index=0&id=4d971186&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d971186",
  null
  
)

export default component.exports